<template>

	<div>

		<el-row class="mb-3">
			<p class="mb-1 comfy-text">Por favor confirma los Términos y Condiciones para proceder con el pago:</p>
		</el-row>

		<el-row class="mb-3">
			<template>
				<el-row class="mb-3">
					<el-col :span="2">
						<vs-checkbox color="#123b5a" v-model="politicas" val="politica1">
						</vs-checkbox>
					</el-col>
					<el-col :span="22">
                        Leo y acepto las <a class="font-weight-normal" href="#modalCancelacion" data-toggle="modal" data-target="#modalCancelacion">POLÍTICAS DE SERVICIOS RESERVADOS. LEERLAS ATENTAMENTE</a>.
					</el-col>
				</el-row>
			</template>
            <!-- <template v-if="generoCliente && !reservador">
                <el-row class="mb-3" :span="24">
                    <span class="demonstration">Indícanos tu género</span>
                    <el-select class="w-100" v-model="genero" clearable placeholder="Selecciona..." size="large">
                        <el-option
                            v-for="item in generos"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-row>
            </template>
            <template v-if="cumpleCliente && !reservador">
                <el-row class="mb-5">
                    <span class="demonstration">Indícanos tu fecha de nacimiento</span>
                    <el-date-picker
                        v-model="birthdate"
                        type="date"
                        placeholder="Fecha de nacimiento"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-row>
            </template> -->
		</el-row>

        <div v-if="reservador">
            <el-row class="mb-3">
                <template>
                    <div class="center content-inputs">
                        <vs-input block v-model="reservadorData.nombre" placeholder="Nombre del cliente" />
                    </div>
                </template>
            </el-row>

            <el-row class="mb-3">
                <VuePhoneNumberInput 
                ref="vuephoneref"
                v-model="celularReservador" 
                :default-country-code="cliente.countrycode" 
                :translations="translations"
                @update="updateCelularReservador"
                />
            </el-row>

            <el-row class="mb-3">
                <template>
                    <div class="center content-inputs">
                        <vs-input block v-model="reservadorData.correo" placeholder="Correo del cliente" />
                    </div>
                </template>
            </el-row>

            <el-row class="mb-3">
                <template>
                    <div class="center content-inputs">
                        <vs-input block v-model="reservadorData.cedula" placeholder="Cédula del cliente" />
                    </div>
                </template>
            </el-row>
        </div>

		<el-row v-if="!reservador" class="mb-3">
            <VuePhoneNumberInput 
            ref="vuephoneref"
            v-model="cliente.e164" 
            :default-country-code="cliente.countrycode" 
            :translations="translations"
            @update="updateCelular"
            />
			<!-- <vs-input block label-placeholder="Confirma tu número celular" maxlength="10" v-model="cliente.telefono" @input="reglaNumero">
				<template v-if="!celularCliente" #message-danger>
					Requerido y debe ser de 10 números
				</template>
			</vs-input> -->
		</el-row>

		<el-row>

			<el-form method="post" ref="formularioPago" id="form-payu" action="https://checkout.payulatam.com/ppp-web-gateway-payu/">
                <input name="merchantId" :type="text" :value="formularioPago.merchantId">
                <input name="accountId" :type="text" :value="formularioPago.accountId">
                <input name="description" :type="text" :value="formularioPago.description">
                <input name="referenceCode" :type="text" :value="formularioPago.referenceCode">
                <input name="amount" :type="text" :value="formularioPago.amount">
                <input name="tax" :type="text" value="0">
                <input name="taxReturnBase" :type="text" value="0">
                <input name="currency" :type="text" value="COP">
                <input name="signature" :type="text" :value="formularioPago.signature">
                <input name="buyerEmail" :type="text" :value="cliente.correo">
                <input v-if="developTest" name="test" :type="text" value="1">
                <input name="responseUrl" :type="text" :value="formularioPago.responseUrl">
                <input name="confirmationUrl" :type="text" :value="formularioPago.confirmationUrl">
				<el-form-item>
                    <el-button id="click_paso_pago" class="btn-block" :disabled="habilitarPago" :loading="procesandoPago" type="primary" @click.prevent="verificarProcesoPago">{{ (habilitarPago == true) ? 'Selecciona y completa todas las casillas' : 'Click aquí para realizar pago' }}</el-button>
				</el-form-item>
			</el-form>

		</el-row>

		<el-row v-if="error">

			<el-col :span="24">
				<div class="text-danger" v-text="error"></div>
			</el-col>

		</el-row>

	</div>

</template>

<style type="text/css">
    #click_paso_pago span{
        pointer-events: none;
    }
    .vs-input__label{
        opacity: 1;
    }
    .country-selector__label, .input-tel__label{
        top: 5px !important;
    }
</style>

<script>
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css';
    Vue.component('VuePhoneNumberInput', VuePhoneNumberInput);

	export default {
		components: {},
        props: [
            'servicio', 'cliente', 'url'
        ],
        data() {
            return {
                politicas: [],
                generos: [{
                    value: 'masculino',
                    label: 'Masculino'
                }, {
                    value: 'femenino',
                    label: 'Femenino'
                }],
                genero: '',
                birthdate: '',
                ciudad: '',
                formularioPago: {
                    merchantId: '',
                    accountId: '',
                    description: '',
                    referenceCode: '',
                    amount: '',
                    tax: '',
                    taxReturnBase: '',
                    currency: '',
                    signature: '',
                    buyerEmail: '',
                    responseUrl: `${this.url}/cliente/${this.ciudad}/landing-pago`, 
                    confirmationUrl: `${this.url}/api/confirmacion-pago`,
                },
                procesandoPago: false,
                habilitarPago: true,
                error: '',
                text: this.checkInputs(),
                developTest: this.checkEnvironment(),
                reservador: false,
                reservadorData: {
                    nombre: '',
                    celular: '',
                    codigo: '',
                    codigopais: '',
                    correo: '',
                    cedula: '',
                },
                celularReservador: '',
                countriesList: ['CO', 'ES', 'US'],
                translations: {
                    countrySelectorLabel: 'Indicativo',
                    countrySelectorError: 'Debes elegir país',
                    phoneNumberLabel: 'Número de teléfono',
                    example: 'Ejemplo:'
                }
            }
        },
        computed: {
            // celularCliente(){
            //     if(this.cliente.telefono == null || this.cliente.telefono == '' ){
            //         return false
            //     }else{
            //         if(this.cliente.telefono.length == 10){
            //             return true
            //         }
            //     }
            // },
            generoCliente(){
                if(this.cliente.gender == null){
                    return true
                }else{
                    return false
                }
            },
            cumpleCliente(){
                if(this.cliente.birthdate == null){
                    return true
                }else{
                    return false
                }
            }
        },
        watch: {
            politicas: function(){
                if(this.politicas.length < 1){
                    this.habilitarPago = true
                    this.error = ''
                }
                if(!this.reservador && this.$refs.vuephoneref.results.isValid && this.politicas.length == 1){
                    this.habilitarPago = false
                }
                if(this.reservador && this.reservadorData.nombre != '' && this.reservadorData.correo != '' && this.$refs.vuephoneref.results.isValid && this.politicas.length == 1){
                    this.habilitarPago = false
                    this.error = ''
                }
            },
            'cliente.telefono': function(){
                if(this.$refs.vuephoneref.results.isValid && this.politicas.length == 1){
                    this.habilitarPago = false
                    this.error = ''
                }else {
                    this.habilitarPago = true
                }
            },
            'reservadorData.nombre': function(){
                if(this.politicas.length == 1 && this.reservadorData.nombre != '' && this.reservadorData.correo != '' && this.$refs.vuephoneref.results.isValid){
                    this.habilitarPago = false
                    this.error = ''
                }else{
                    this.habilitarPago = true
                }
            },
            'reservadorData.celular': function(){
                if(this.politicas.length == 1 && this.reservadorData.nombre != '' && this.reservadorData.correo != '' && this.$refs.vuephoneref.results.isValid){
                    this.habilitarPago = false
                    this.error = ''
                }else{
                    this.habilitarPago = true
                }
            },
            'reservadorData.correo': function(){
                if(this.politicas.length == 1 && this.reservadorData.nombre != '' && this.reservadorData.correo != '' && this.$refs.vuephoneref.results.isValid){
                    this.habilitarPago = false
                    this.error = ''
                }else{
                    this.habilitarPago = true
                }
            },
            'reservadorData.cedula': function(){
                this.reservadorData.cedula = this.reservadorData.cedula.replace(/[^0-9]/g, '');
            }
        },
        methods: {
            updateCelular(payload) {
                // console.log(payload)
                if(payload.isValid){
                    this.cliente.codigopais = payload.countryCallingCode
                    this.cliente.telefono = payload.nationalNumber
                    this.cliente.countrycode = payload.countryCode
                    // this.celularCliente = true
                    this.habilitarPago = false
                }else{
                    this.habilitarPago = true
                }
            },
            updateCelularReservador(payload) {
                // console.log(payload)
                if(payload.isValid){
                    this.cliente.codigopais = payload.countryCallingCode
                    this.cliente.telefono = payload.nationalNumber
                    this.reservadorData.codigo = payload.countryCallingCode
                    this.reservadorData.celular = payload.nationalNumber
                    this.reservadorData.codigopais = payload.countryCode
                    // this.celularCliente = true
                    this.habilitarPago = false
                }else{
                    this.habilitarPago = true
                }
            },
            reglaNumero(val){
                this.cliente.telefono = val.replace(/[^0-9]/g, '');
            },
            verificarProcesoPago(){
                this.error = ''
                this.procesandoPago = true
                if(this.politicas.length == 1 && this.$refs.vuephoneref.results.isValid){
                    this.confirmarPago()
                }else {
                    // console.log('--- problemas validación de datos ---')
                    this.procesandoPago = false
                    this.habilitarPago = true
                    this.error = 'Debes validar que todas las casillas estén marcadas y tengas un número de celular para contactarte.'
                    return
                }
            },
            confirmarPago(){
                this.error = ''
                this.servicio.valorCobertura = this.servicio.desplazamientoUno + this.servicio.desplazamientoDos + this.servicio.desplazamientoTres + this.servicio.desplazamientoCuatro + this.servicio.desplazamientoCinco
                if(!this.servicio.codigo.valido){
                    this.servicio.codigo.codigoInput = ''
                }
                var url = '/cliente/solicitud-servicio'
                // console.log(this.servicio)
                // return
                axios.post(url, {
                    servicio: this.servicio,
                    cliente: this.cliente,
                    birthdate: this.birthdate,
                    reservadorData: this.reservadorData
                }).then(response => {
                    if(response.data.code == '400'){
                        // console.log(response.data)
                        this.error = response.data.message
                        this.habilitarPago = false
                        this.procesandoPago = false
                    }else if(response.data.code == '200'){
                        this.formularioPago.amount = response.data.infopago.amount
                        this.formularioPago.description = response.data.infopago.description
                        this.formularioPago.referenceCode = response.data.infopago.codigo
                        this.formularioPago.signature = response.data.infopago.signature
                        this.formularioPago.accountId = response.data.infopago.accountId
                        this.formularioPago.merchantId = response.data.infopago.merchantId
                        this.formularioPago.responseUrl = `${this.url}/cliente/${response.data.infopago.ciudad}/landing-pago`,
                        setTimeout(function(){
                            document.querySelector('#form-payu').submit()
                        }, 2000)
                    }else if(response.data.code == '201'){
                        // console.log('--- pago con Comfy créditos confirmado ---')
                        this.ciudad = response.data.infopago.ciudad
                        window.location.replace(`/cliente/${this.ciudad}/pagolocal-` + response.data.infopago.codigo);
                    }else if(response.data.code == '202'){
                        // console.log('--- reservador no puede crear servicio ---')
                        this.error = response.data.message
                        this.habilitarPago = true
                        this.procesandoPago = false
                    }
                }).catch(error => {
                    console.log(error)
                })
            },
            checkEnvironment(){
                if(process.env.NODE_ENV == 'development'){
                    return true
                }
                return false
            },
            checkInputs(){
                if(process.env.NODE_ENV == 'development'){
                    return 'text'
                }
                return 'hidden'
            }
        },
        mounted() {
            // console.log('--- final component mounted ---')
            if(this.cliente.perfil == 'reservador'){
                // this.cliente.telefono = ''
                this.reservador = true
            }
            // if(this.politicas.length == 1 && this.$refs.vuephoneref.results.isValid){
            //     this.habilitarPago = false
            // }else{
            //     this.habilitarPago = true
            // }
            // console.log(this.$refs.vuephoneref)
        }
    };

</script>